import { createContext } from "react";
import { GlobalStateType } from "../App";

const GlobalStateContext = createContext<GlobalStateType | null>(null);

export default GlobalStateContext;
